import { toast } from 'react-toastify'
import { i18n } from '../translate/i18n'
import { isString } from 'lodash'

const toastError = err => {
  console.log(err.response)

  const errorCode = err.response?.status
  const errorMsg = err.response?.data?.error
  const errorDetails = err.response?.data?.details

  const getErrorMessageWithDetails = () => {
    if (errorMsg === 'ERR_OTHER_OPEN_TICKET' && errorDetails) {
      const queueName = errorDetails?.queue?.name
      const userName = errorDetails?.user?.name

      if (queueName || userName) {
        const detailsMessage = i18n.t('backendErrors.ERR_OTHER_OPEN_TICKET_DETAILS', {
          queue: queueName || '-',
          user: userName || '-',
          interpolation: { escapeValue: false },
        })

        return `${i18n.t(`backendErrors.${errorMsg}`)} ${detailsMessage}`.trim()
      }
    }

    return null
  }

  const errorMessageWithDetails = getErrorMessageWithDetails()

  if (errorCode === 500) {
    console.error(`Error: ${i18n.t(`backendErrors.${errorMsg}`)}`)
    return
  }

  if (errorMessageWithDetails) {
    console.error(`Error: ${errorMessageWithDetails}`)

    toast.error(errorMessageWithDetails, {
      toastId: `${errorMsg}_DETAILS`,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: 'light',
    })

    return
  }

  if (errorMsg) {
    if (i18n.exists(`backendErrors.${errorMsg}`)) {
      console.error(`Error: ${i18n.t(`backendErrors.${errorMsg}`)}`)

      toast.error(i18n.t(`backendErrors.${errorMsg}`), {
        toastId: errorMsg,
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })

      return
    } else {
      console.error(`Error: ${errorMsg}`)
      // Optionally log the error to an external service here

      toast.error(errorMsg, {
        toastId: errorMsg,
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })

      return
    }
  }
  if (isString(err)) {
    console.error(`Error: ${err}`)
    // Optionally log the error to an external service here

    toast.error(err, {
      toastId: errorMsg,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: 'light',
    })

    return
  } else {
    console.error('An error occurred!')
    console.error(err)
    console.error(err.message)
    // Optionally log the error to an external service here

    toast.error('An error occurred!', {
      toastId: 'An error occurred!',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      theme: 'light',
    })

    return
  }
}

export default toastError
